import { CircularProgress } from "@material-ui/core";
import React, { useEffect } from "react";

const Progress = ({ progress, parentComponent = "ChatDialog" }) => {
  const changePadding = () => {
    if (parentComponent == "ChatDialog") return;
    let element = document.getElementById("scroll-to-bottom-chat-drawer-home");
    if (element) {
      element.style.paddingBottom = "5rem";
    }
  };
  useEffect(() => {
    changePadding();
    return () => {
      if (parentComponent == "ChatDialog") return;
      let element = document.getElementById("scroll-to-bottom-chat-drawer-home");
      if (element) {
        element.style.paddingBottom = "0px";
      }
    };
  }, []);

  switch (parentComponent) {
    case "ChatDialog":
      return (
        <div style={styles.chatDialogProgress} id="task-action-progress">
          {progress.label}
          <CircularProgress style={{ margin: "0 0px 0px 15px" }} color="primary" size={20} />{" "}
        </div>
      );
    default:
      return (
        <div
          style={styles.progress}
          id="task-action-progress"
          className="gradient-background-progress absolute-bottom-0"
        >
          <CircularProgress style={{ margin: "0 10px 0px 10px" }} color="white" size={20} />{" "}
          {progress.label}
        </div>
      );
  }
};

export default Progress;

const styles = {
  progress: {
    width: "100%",
    padding: "21px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-start",
    fontSize: "13px",
  },
  chatDialogProgress: {
    width: "100%",
    padding: "10px 0px 15px 0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    fontSize: "13px",
  },
};
